// Từ điển nhãn thẻ của màn Đăng ký ca (khối ảnh, trang điểm, kinh doanh).
//
// Tách khỏi component vì bài hướng dẫn gọi tên thẻ theo đúng chữ trên màn; gõ
// chuỗi ở hai nơi thì đổi một nơi là bài chỉ tới thẻ không còn tồn tại, im
// lặng. Khoá chính là `value` của `TabsTrigger`, cũng là giá trị `?tab=` mà
// thông báo đơn nghỉ dùng để mở thẳng đúng thẻ.

export const EKIP_SHIFT_TAB_LABEL = {
  register: "Đăng ký",
  approve: "Duyệt",
  absence: "Báo nghỉ",
} as const;

export type EkipShiftTabKey = keyof typeof EKIP_SHIFT_TAB_LABEL;
